import { createSelector } from 'reselect';

import { getFavorites } from '../form-designer/selectors/common.selectors';
import { findFavorite, getHeaderTitleText } from '../form-designer/utils/common.utils';

export const getLinkPreviewResults = (state) => state.linkPreviewResults ?? {};

const getComponentProps = (_, props) => props || {};

export const getCachedLinkPreviewData = createSelector(
  [getLinkPreviewResults, getComponentProps],
  (linkPreviewResults, { linkPreviewKey }) => linkPreviewResults[linkPreviewKey]
);

export const getIsFavorite = createSelector(
  [getFavorites, getComponentProps],
  (favorites, { revisionNumber, recordNumber, userKey, entityType }) => {
    const headerTitleText = getHeaderTitleText({ revisionNumber, recordNumber, userKey });
    return favorites.findIndex(findFavorite(entityType, headerTitleText)) !== -1;
  }
);
